// Permissions come from the canonical membership, never the user root/profile.
export function canonicalMemberPermissions(member = {}) {
  if (!member.permissions || typeof member.permissions !== "object" || Array.isArray(member.permissions)) return undefined;
  return Object.fromEntries(Object.entries(member.permissions).map(([key, value]) => [key, value === true]));
}

export function canonicalMemberRole(member = {}) {
  const role = String(member.role || "").trim().toLowerCase().replace(/[\s-]+/g, "_");
  return ["owner", "admin", "super_admin", "staff", "viewer", "manager", "sales", "salesperson", "sales_person",
    "accounts", "account", "accountant", "finance", "project_coordinator", "coordinator", "project_manager"].includes(role) ? role : "staff";
}

export const workspaceBootstrapRole = role => ["owner", "admin", "super_admin"].includes(role) ? "owner" : "staff";
